import { h, Component, ComponentChildren } from 'preact'
import {isChangeEvent} from '../../libs/preact-entry'

type Props = {
  children: ComponentChildren,
  title: string,
  onTitleChanged: CallableFunction
}

type State = {
  showTitleInput: boolean
}

class TitleInput extends Component<Props, State> {
  titleInputRef: HTMLElement | undefined

  constructor (props: Props) {
    super(props)
    this.state = {
      showTitleInput: false
    }
  }

  componentDidMount () {
    document.addEventListener('mousedown', (e: MouseEvent) => this.onClickOutsideOfTitle(e))
    document.addEventListener('keypress', (e: KeyboardEvent) => this.onPressEnterInTitle(e))
  }

  onTitleClicked () {
    this.setState({ showTitleInput: true }, () => {
      if (this.titleInputRef) {
        this.titleInputRef.focus()
      }
    })
  }

  onClickOutsideOfTitle (e: MouseEvent) {
    if (this.titleInputRef && !this.titleInputRef.contains(e.target as Node)) {
      this.titleInputRef.blur()
      this.setState({ showTitleInput: false })
    }
  }

  onPressEnterInTitle (e: KeyboardEvent) {
    if (this.titleInputRef && e.keyCode === 13) {
      this.titleInputRef.blur()
      this.setState({ showTitleInput: false })
    }
  }

  render ({ children, title, onTitleChanged }: Props, state: State) {
    return (
      <div class='title-input'>
        {this.state.showTitleInput
          ? <input
            class='qa-title-input form-control'
            type='text'
            value={title}
            required
            onChange={e => {
              if (isChangeEvent(e)) {
                onTitleChanged(e.target.value.trim())
              }
            }}
            maxLength={250}
            ref={(titleInput) => { this.titleInputRef = titleInput }}
          />
          : <div class='title-input__title' onClick={() => this.onTitleClicked()}>
            {children}
          </div>
        }
      </div>
    )
  }
}

export default TitleInput
